import { Button, Result } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { callEventTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { loginActions } from "../../../../pages/LoginPage/reducer";
import { OP_STATUS } from "../../../../util/varibles/constants";
import { ITreatment2 } from "../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../Icon";
import Header from "../../_components/Header2";
import NextStep from "../../_components/StepControl/NextStep";
import TreatmentSteps from "../../_components/TreatmentSteps";
import stylesOp from "../style.module.scss";

const Views: { [id: string]: React.FC } = {
    [OP_STATUS.APPROVED]: () => {
        return <div className='flex justify-center mt-5'>
            <NextStep name='start operation'>
                Start operation
            </NextStep>
        </div>
    },
    [OP_STATUS.PROCESSING]: () => {
        return <TreatmentSteps />
    },
    [OP_STATUS.FINISHED]: () => {
        const dispatch = useDispatch();

        return <Result
            status="success"
            title={<div className='font-s16 font-w4'>Operation is completed</div>}
            extra={<div className='flex justify-content-center'>
                <Button className='bt-primary' onClick={() => dispatch(loginActions.getOpsOfVessel())}>
                    Continue
                </Button>
            </div>}
        />
    }
}

export default function Treatment() {
    const [site] = useTrackingOp(state => (state.op?.operation as ITreatment2).site);
    const [status] = useTrackingOp(state => state.op?.operation.status);
    const { getWeather } = callEventTrackingOp();

    useEffect(() => {
        getWeather();
    }, [getWeather])

    const { [status || ""]: View } = Views;
    const { name: siteName = "" } = site || {}

    return <div className="flex flex-col h-full">
        <Header icon={<Icon icon={ICON_NAME.TREATMENT} />} >
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{siteName}</span>
            </div>
        </Header>
        <div className="flex-1 overflow-y-auto ">
            {View && <View />}
        </div>
    </div>
}